module.exports = __webpack_public_path__ + "img/3013d97e57b71507e42cce1e99f8ee0d.98c9108a.png";